import React, {useEffect, useState} from "react"
import {Card, Button, CardBody, Row, Col, UncontrolledTooltip} from "reactstrap"
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {LargeModal} from "../../../components/Common/LargeModal";
import TableLoader from "../../../components/Common/TableLoader";

function TicketTable(props) {
    const { data,
        modalData,
        type} = props
    let isGameSet = 0
    if (data.length && data[0].hasOwnProperty("pragmatic_game_id")) {
        isGameSet = 1;
    }
    else if(data.length && data[0].hasOwnProperty("turbo_gametype_id")){
        isGameSet = 2;
    }
    else if(data.length && data[0].hasOwnProperty("action_id")){
        isGameSet = 3;
    } else if (data.length && data[0].hasOwnProperty("game_id")) {
      isGameSet = 4
    }

    const _renderOddName = (f, odd) => {
        if (odd?.player) {
            return odd?.player?.name;
        }
        let text = odd?.market_spec?.name ?? "";

        text = text.replaceAll("{$competitor1}", f?.competitors[0]?.name);
        text = text.replaceAll("{$competitor2}", f?.competitors[1]?.name);

        text = text.replaceAll("{total}", odd?.special_bet_value);
        text = text.replaceAll("{total}",odd?.special_bet_value);
        return text;
    };
    const selectRow = {
        mode: "checkbox",
    }

    const [isOpen, setIsOpen] = useState(false)

    //pagination customization
    const pageOptions = {
        sizePerPage: 20,
        totalSize: data.length,
        custom: true,
    }
    const { SearchBar } = Search
    const cardsData = [
        {
            color: "primary",
            fontColor: "text-white",
            title: "Total Stake",
            description: modalData.stake?parseFloat(modalData.stake).toFixed(2):0,
            borderClass: "",
        },
        {
            color: "success",
            fontColor: "text-white",
            title: "Effective Stake",
            description: modalData.stake_after_tax?parseFloat(modalData.stake_after_tax).toFixed(2): 0,
            borderClass: "",
        },
        {
            color: "info",
            fontColor: "text-white",
            title: "Boost",
            description: modalData.stake_after_tax?parseFloat(modalData.bonus_amount).toFixed(2): 0,
            borderClass: "",
        },
        {
            color: "warning",
            fontColor: "text-dark",
            title: "Possible Win",
            description: modalData.to_win?modalData.to_win:0,
            borderClass: "",
        },
    ]

    const modalColumns = [
        {
            dataField: "created_at",
            text: "Time",
            sort: true,
            formatter: (cell1, row1) => (

                <>{new Date(parseInt(row1.odd?.fixture_market?.fixture?.match_date?.$date?.$numberLong)).toLocaleString('en-GB')}</>
            ),
        },
        {
            dataField: "channel",
            text: "Event",
            sort: true,
            formatter: (cell1, row1) => (
                <>
                    {row1.odd?row1.odd.fixture_market.fixture.tournament.sport.name:""}
                    <i className="mdi mdi-information font-size-18" id={`addtooltip${row1?.id}`} />
                    <UncontrolledTooltip placement="right" target={`addtooltip${row1?.id}`} style={{'width':'100%'}}>
                        <p style={{'margin-bottom':'0px','text-align':'left'}}>Sport: {row1.odd?row1.odd.fixture_market.fixture.tournament.sport.name:""}</p>
                        <p style={{'margin-bottom':'0px','text-align':'left'}}>Location: {row1.odd?row1?.odd?.fixture_market?.fixture?.tournament?.category?.name:""}</p>
                        <p style={{'margin-bottom':'0px','text-align':'left'}}>League: {row1.odd?row1.odd.fixture_market.fixture.tournament.name:""}</p>
                        <p style={{'margin-bottom':'0px','text-align':'left'}}>Event: {row1.odd?row1.odd.fixture_market.fixture.competitors[0].name+' vs':""} {row1.odd?row1.odd.fixture_market.fixture.competitors[1].name:""}</p>
                    </UncontrolledTooltip>
                </>
            ),
        },
        {
            dataField: "is_live",
            text: "Type",
            sort: true,
            formatter: (cell1, row1) => (
                <>{(row1.odd?.is_live==1)?"Live":"Pre-Match"}</>
            ),
        },
        {
            dataField: "channel",
            text: "Fixture",
            sort: true,
            formatter: (cell1, row1) => (
                <>{row1.odd?row1.odd.fixture_market.fixture.competitors[0].name+' vs':""} {row1.odd?row1.odd.fixture_market.fixture.competitors[1].name:""}
                    {/*<i className="mdi mdi-information font-size-18" id="addtooltip1" />*/}
                    {/*<UncontrolledTooltip placement="right" target="addtooltip1">*/}
                    {/*  <p>Tournament: {row1.odd?row1.odd.fixture_market.fixture.tournament.name:""}</p>*/}
                    {/*</UncontrolledTooltip>*/}
                </>
            ),
        },
        {
            dataField: "price",
            text: "Odds",
            sort: true,
            formatter: (cell1, row1) => (
                <>{row1?.price.toFixed(2)}</>
            ),
        },
        {
            dataField: "test",
            text: "Selection",
            sort: true,
            formatter: (cell1, row1) => (
                <>
                    {(row1?.odd?.length != 0 && row1?.odd!=null)
                        ?
                        _renderOddName(
                            row1?.odd?.fixture_market?.fixture,
                            row1?.odd
                        ) : ''
                    }
                    <i className="mdi mdi-information font-size-18" id={`addtooltip2${row1?.id}`} />
                    <UncontrolledTooltip placement="top" target={`addtooltip2${row1?.id}`}>
                        <p style={{'margin-bottom':'0px'}}>Market: {row1.odd?row1.odd.fixture_market.market.name:""}</p>
                    </UncontrolledTooltip>


                </>
            ),
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (cell1, row1) => (
              <>   
                {
                  data?.bet_settlement_date &&
                  <Button
                    type="button"
                    color=
                    {(row1?.is_cancel_by_admin) ? "info" :
                      (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled == null && row1.is_won == null) ? 'info' :

                        (row1?.status) ? "success" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "secondary" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "primary" : ((row1?.is_won) ? "success" : "danger")))
                    }

                    className="btn-sm"
                  >
                    {(row1?.is_cancel_by_admin) ? "Void" :
                      (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled == null && row1.is_won == null) ? 'Pending' :

                        (row1?.status) ? "Won" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "Cancel" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "Void" : ((row1?.is_won) ? "Won" : "Lost")))
                    }

                  </Button>
                }
              </>
          
            ),
        },
    ]

    const TurboGamesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "Channel",
        text: "Channel",
        formatter: (cell, row) => <>{"Online"}</>,
        sort: true,
      },
      {
        dataField: "game.name",
        text: "Product",
        sort: true,
      },
      {
        dataField: "created_at",
        text: "Date Created",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "bets",
        text: "Bets",
        sort: true,
        formatter: (cell, row) => <>{1}</>,
      },
      {
        dataField: "stake",
        text: "Stake",
        sort: true,
        formatter: (cell, row) => <>{Number(row?.stake).toFixed(2)}</>,
      },
      {
        dataField: "amount",
        text: "NetWin",
        sort: true,
        formatter: (cellContent, row) =>
          row?.amount === null ? 0 : Number(row?.amount).toFixed(2),
      },

      // {
      //   dataField: "channel",
      //   text: "Channel",
      //   sort: true,
      // },

      {
        dataField: "resultType",
        text: "Status",
        sort: true,
        formatter: (cellContent, row) =>
          row.resultType == "won"
            ? "won"
            : row.resultType == "lost"
            ? "lost"
            : "void",
      },
    ]
    const SpribeGamesColumns = [
      {
        dataField: "action_id",
        text: "ID",
        sort: true,
      },
      // {
      //     dataField: "user.phone_number",
      //     text: "User Name",
      //     sort: true,
      // },
      {
        dataField: "Channel",
        text: "Channel",
        formatter: (cell, row) => <>{"Online"}</>,
        sort: true,
      },
      {
        dataField: "game.name",
        text: "Product",
        sort: true,
      },
      {
        dataField: "created_at",
        text: "Date Created",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
      // {
      //     dataField: "provider_tx_id",
      //     text: "Provider Tx Id",
      //     sort: true,
      //     // formatter: (cell, row) => <>{Number(row?.provider_tx_id ?? 1).toLocaleString('en-GB')}</>,
      // },
      {
        dataField: "stake",
        text: "Stake",
        sort: true,
        formatter: (cell, row) => (
          <>{Number(Number(row?.stake).toFixed(2)).toLocaleString("en-GB")}</>
        ),
      },
      {
        dataField: "win_amount",
        text: "NetWin",
        sort: true,
        formatter: (cellContent, row) =>
          row.win_amount === null
            ? 0
            : Number(Number(row?.win_amount).toFixed(2)).toLocaleString(
                "en-GB"
              ),
      },

      {
        dataField: "platform",
        text: "Platform",
        sort: true,
      },
    ]
    const PragmaticGamesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "Channel",
        text: "Channel",
        formatter: (cell, row) => <>{"Online"}</>,
        sort: true,
      },
      {
        dataField: "game.game_name",
        text: "Product",
        sort: true,
      },
      {
        dataField: "created_at",
        text: "Date Created",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "bets",
        text: "Bets",
        sort: true,
        formatter: (cell, row) => <>{row.bets ?? 1}</>,
      },
      {
        dataField: "amount",
        text: "Stake",
        sort: true,
        formatter: (cell, row) => <>{row.amount.toFixed(2)}</>,
      },
      {
        dataField: "won_amount",
        text: "NetWin",
        sort: true,
        formatter: (cellContent, row) =>
          row?.won_amount === null ? 0 : (row?.won_amount).toFixed(2),
      },

      // {
      //   dataField: "channel",
      //   text: "Channel",
      //   sort: true,
      // },

      {
        dataField: "is_won",
        text: "Status",
        sort: true,
        formatter: (cellContent, row) =>
          row.is_won == 1 ? "won" : row.is_won == 0 ? "lost" : "pending",
      },
    ]

    const TicketsColumns = [
      {
      dataField: "id",
      text: "Ticket Id",
      sort: true,
      formatter: (cellContent, row) => {
        const isBonusUsed = row.is_bonus_used === 1
        const isSignupUsed = row.is_signup_freebet_used === 1
        const color = isBonusUsed ? "red" : isSignupUsed ? "green" : ""
        const fontWeight = isBonusUsed || isSignupUsed ? "bold" : "normal" 
        const textStyle = { color, fontWeight }

        return <span style={textStyle}>{cellContent}</span>
        },
      },
      {
        dataField: "Category",
        text: "Category",
        sort: true,
        formatter: (cellContent, row) => <>{row?.category?.name ?? "Online"}</>,
      },
      {
        dataField: "Type",
        text: "Type",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {row?.bets?.length > 1 ? `Multi(${row?.bets?.length})` : "Single"}
          </>
        ),
      },
      {
        dataField: "Date_Time",
        text: "Date & Time",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "Stake",
        text: "Stake",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {Number(parseFloat(row.stake).toFixed(2)).toLocaleString("en-GB")}
          </>
        ),
      },
      {
        dataField: "StakeTax",
        text: "Stake Tax",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {Number(
              parseFloat(row.stake - row.stake_after_tax).toFixed(2)
            ).toLocaleString("en-GB")}
          </>
        ),
      },
      {
        dataField: "EffectiveStake",
        text: "Effective Stake",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {Number(parseFloat(row.stake_after_tax).toFixed(2)).toLocaleString(
              "en-GB"
            )}
          </>
        ),
      },
      {
        dataField: "total_odds",
        text: "Odds",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {Number(parseFloat(row.total_odds).toFixed(2)).toLocaleString(
              "en-GB"
            )}
          </>
        ),
      },
      {
        dataField: "Boost",
        text: "Boost",
        sort: true,
        formatter: (cellContent, row) => (
          <>{parseFloat(row?.bonus_amount ?? 0).toFixed(2)}</>
        ),
      },
      {
        dataField: "wht",
        text: "WHT",
        sort: true,
        formatter: (cellContent, row) => (
          <>{Number(parseFloat(row.wht).toFixed(2)).toLocaleString("en-GB")}</>
        ),
      },
      {
        dataField: "to_win",
        text: "Possible Win",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {Number(parseFloat(row.to_win).toFixed(2)).toLocaleString("en-GB")}
          </>
        ),
      },
      {
        dataField: "Status",
        text: "Status",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            {row.status == 1
              ? "Won"
              : row.status == 0
              ? "Lost"
              : row.status == 3
              ? "Cashed Out"
              : row.status == 2
              ? "Void"
              : "Pending"}
          </>
        ),
      },
    ]

        const BigWinsColumns = [
          {
            dataField: "round_id",
            text: "ID",
            sort: true,
          },
          // {
          //     dataField: "user.phone_number",
          //     text: "User Name",
          //     sort: true,
          // },
          {
            dataField: "Channel",
            text: "Channel",
            formatter: (cell, row) => <>{"Online"}</>,
            sort: true,
          },
          {
            dataField: "game.name",
            text: "Product",
            sort: true,
          },
          {
            dataField: "created_at",
            text: "Date Created",
            sort: true,
            formatter: (cell, row) => {
              const date = new Date(row?.created_at)
              const formattedDate = date.toLocaleString("en-GB", {
                timeZone: "CAT",
                hour12: true,
              })
              const capitalizedDate = formattedDate.replace(
                /(am|pm)/gi,
                match => match.toUpperCase()
              )

              return <>{capitalizedDate}</>
            },
          },
          // {
          //     dataField: "provider_txv_id",
          //     text: "Provider Tx Id",
          //     sort: true,
          //     // formatter: (cell, row) => <>{Number(row?.provider_tx_id ?? 1).toLocaleString('en-GB')}</>,
          // },
          {
            dataField: "stake",
            text: "Stake",
            sort: true,
            formatter: (cell, row) => (
              <>
                {Number(Number(row?.stake).toFixed(2)).toLocaleString("en-GB")}
              </>
            ),
          },
          {
            dataField: "win_amount",
            text: "NetWin",
            sort: true,
            formatter: (cellContent, row) =>
              row.win_amount === null
                ? 0
                : Number(Number(row?.win_amount).toFixed(2)).toLocaleString(
                    "en-GB"
                  ),
          },

          //   {
          //     dataField: "platform",
          //     text: "Platform",
          //     sort: true,
          //   },
  ]
  
    const defaultSorted = [
        {
            dataField: "orderId",
            order: "desc",
        },
    ]

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            if(props.item!="Pragmatic" && props.item!="Turbo" && props.item!="Spribe"){
                if(row?.jackpot_id!=0){
                    props.callByJackpotId(row.jackpot_id,row.id)
                }
                else{
                    props.callById(row.id)
                }

                setIsOpen(true)
            }
        },
    }
    return (
        <React.Fragment>
        <Card>
            <CardBody>
                <div className="mb-4 h4 card-title">{props.item}</div>
                {
                    (props.loadingMessage && props.loadingMessage == "1") ?
                        <TableLoader/> :
                        <PaginationProvider
                                pagination={paginationFactory(pageOptions)}
                                  keyField="id"
                                  columns={
                                      isGameSet == 1
                                          ? PragmaticGamesColumns
                                          : isGameSet == 2
                                          ? TurboGamesColumns
                                          : isGameSet == 3
                                          ? SpribeGamesColumns
                                          : isGameSet == 4
                                          ? BigWinsColumns
                                          : TicketsColumns
                                  }
                                  data={data}
                           >
                            {({ paginationProps, paginationTableProps }) => (
                                <ToolkitProvider
                                    keyField="id"
                                    data={data}
                                    columns={
                                      isGameSet == 1
                                          ? PragmaticGamesColumns
                                          : isGameSet == 2
                                          ? TurboGamesColumns
                                          : isGameSet == 3
                                          ? SpribeGamesColumns
                                          : isGameSet == 4
                                          ? BigWinsColumns
                                          : TicketsColumns
                                  }
                                    bootstrap4
                                    search
                                >
                                    {toolkitProps => (
                                        <React.Fragment>
                                            <Row>
                                                <Col xl="12">
                                                    <div className="table-responsive">
                                                        <BootstrapTable
                                                            keyField="id"
                                                            responsive
                                                            bordered={false}
                                                            striped={false}
                                                            defaultSorted={defaultSorted}
                                                            // selectRow={selectRow}
                                                            classes={
                                                                "table align-middle table-nowrap table-check"
                                                            }
                                                            headerWrapperClasses={"table-light"}
                                                            {...toolkitProps.baseProps}
                                                            {...paginationTableProps}
                                                            rowEvents={rowEvents}
                                                            hover
                                                            rowClasses={"mytable-hover-row"}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="pagination pagination-rounded justify-content-end">
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        </React.Fragment>
                                    )}
                                </ToolkitProvider>
                            )}
                        </PaginationProvider>
                }

            </CardBody>
        </Card>
            {
                (Object.keys(modalData).length !== 0) ?
                    <LargeModal
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        cardsData={cardsData}
                        betType={"1bet, 2-fold multiple"}
                        size={"xl"}
                        columns={modalColumns}
                        data={modalData}
                    />
                    : ''
            }
        </React.Fragment>

    )
}

export default TicketTable